// =========================================
// Latest Posts
// Mobile/tablet: 1-row slider with a peeking next card.
// Desktop (lg+): Swiper disabled → CSS grid (3-up).
// Swiper comes from the shared swiper-core bundle (window.Swiper).
// Figma: 329:6681 (desktop) / 329:8812 (mobile)
// =========================================
document.addEventListener('DOMContentLoaded', function () {
    const Swiper = window.Swiper;
    if (!Swiper) return;

    const wraps = document.querySelectorAll('[data-lp-slider]');
    if (!wraps.length) return;

    wraps.forEach(function (wrap) {
        const el = wrap.querySelector('.swiper');
        if (!el) return;

        new Swiper(el, {
            slidesPerView: 1.15,
            spaceBetween: 16,
            grabCursor: true,
            breakpoints: {
                576: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                // Desktop: turn Swiper off and let the CSS grid take over.
                992: {
                    enabled: false,
                },
            },
        });
    });
});
